import React from 'react';
import { Play, Flame, Sparkles } from 'lucide-react';
import GameArtwork from './GameArtwork';
import MeritGameCard from '../themes/merit/MeritGameCard';
import BetrunGameCard from '../themes/betrun/BetrunGameCard';
import ZumrutGameCard from '../themes/zumrut/ZumrutGameCard';
import ParisGameCard from '../themes/paris/ParisGameCard';
import HerkulGameCard from '../themes/herkul/HerkulGameCard';
import VegaGameCard from '../themes/vega/VegaGameCard';
import { useActiveTheme } from '../lib/activeTheme';
import { HOOKS, hook } from '../lib/domHooks';

const GameTile = ({ game, onPlay }) => {
  // Merit, Zümrüt ve Herkül şemalarında oyun adı görselin üstünde değil kartın
  // altında, Paris ve Vega'da ise üzerine gelince açılan katmanda durur;
  // katalog sayfaları ana sayfayla aynı kartı kullansın diye burada ayrılır.
  const themeId = useActiveTheme();
  if (themeId === 'merit') {
    return <MeritGameCard game={game} onPlay={onPlay} />;
  }
  if (themeId === 'betrun') {
    return <BetrunGameCard game={game} onPlay={onPlay} />;
  }
  if (themeId === 'zumrut') {
    return <ZumrutGameCard game={game} onPlay={onPlay} />;
  }
  if (themeId === 'paris') {
    return <ParisGameCard game={game} onPlay={onPlay} />;
  }
  if (themeId === 'herkul') {
    return <HerkulGameCard game={game} onPlay={onPlay} />;
  }
  if (themeId === 'vega') {
    // Katalog kartı ana sayfa şeridindekinden ayrılır: referansta oyunun adı
    // kartın altında kendi şeridinde durur (şeritte ise yalnızca görsel var).
    return <VegaGameCard game={game} onPlay={onPlay} variant="catalog" />;
  }

  return (
  <div {...hook(HOOKS.GAME_CARD)} className="game-tile group" onClick={() => onPlay?.(game)}>
    <GameArtwork src={game.img} alt={game.name} />
    <div className="absolute top-2 left-2 flex flex-col gap-1 z-10">
      {game.hot && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold" style={{ background: '#e11d48', color: '#fff' }}>
          <Flame size={10} /> HOT
        </span>
      )}
      {game.new && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold" style={{ background: 'var(--pusu-gold)', color: 'var(--pusu-on-accent)' }}>
          <Sparkles size={10} /> YENİ
        </span>
      )}
    </div>
    <div className="overlay">
      <button className="gold-btn rounded-full w-14 h-14 flex items-center justify-center">
        <Play size={22} fill="var(--pusu-on-accent)" />
      </button>
    </div>
    <div className="absolute inset-x-0 bottom-0 p-2.5 z-10" style={{ background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 100%)' }}>
      <div className="text-xs md:text-sm font-semibold text-white truncate">{game.name}</div>
      <div className="text-[10px] md:text-xs text-gray-400 truncate">{game.provider}</div>
    </div>
  </div>
  );
};

export default GameTile;
